module.exports = __webpack_public_path__ + "img/yetEvaluation.15dbcea4.png";